export enum ReviewVisibilityStatus {
  PUBLIC = "public",
  QUARANTINED = "quarantined",
  FLAGGED = "flagged",
  HIDDEN_DUE_TO_DISPUTE = "hidden_due_to_dispute",
  REMOVED = "removed",
}
